import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Spinner from "src/components/Spinner";

const JACKPOT_API_URL =
  "https://script.google.com/macros/s/AKfycbx7RgitWFoY-Nz61fDRm1EE3z3CBbuuVbwODgcd9N9bFt-OVMz33oT2mJ0JHzoGVTbe/exec";

const CashnadoSpring2026TV = () => {
  const [jackpotAmount, setJackpotAmount] = useState("$100,000");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJackpotAmount = async () => {
      try {
        const timestamp = new Date().getTime();
        const response = await fetch(`${JACKPOT_API_URL}?t=${timestamp}`);
        const data = await response.json();

        let amount = "$100,000";

        if (typeof data === "number") {
          amount = `$${data.toLocaleString()}`;
        } else if (typeof data === "string") {
          amount = data.includes("$")
            ? data
            : `$${parseFloat(data.replace(/,/g, "")).toLocaleString()}`;
        } else if (data && typeof data === "object") {
          const rawValue =
            data.amount || data.value || data.jackpot || data.prize;
          amount =
            typeof rawValue === "number"
              ? `$${rawValue.toLocaleString()}`
              : rawValue;
        }

        setJackpotAmount(amount);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching jackpot amount:", error);
        setLoading(false);
      }
    };

    fetchJackpotAmount();
    const interval = setInterval(fetchJackpotAmount, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <TVContainer>
      {/* Full Screen Background Video */}
      <BackgroundVideo autoPlay muted loop playsInline>
        <source
          src="/videos/Cashnado-Game-Wall(no amount).mp4"
          type="video/mp4"
        />
      </BackgroundVideo>

      {/* Dynamic Amount Overlay - Only visible element */}
      <DynamicAmountOverlay>
        {loading ? <Spinner variant="light" /> : jackpotAmount}
      </DynamicAmountOverlay>

      {/* Hidden elements - kept for future use */}
      <ContentGrid style={{ display: "none" }}>
        {/* LEFT COLUMN - English */}
        <SideColumn>
          <SideBox>
            <IconWrapper
              src={`${process.env.REACT_APP_PGFE_IMG_ASSETS_PATH}promotions/gaming-machines/cashnado-spring-2026/star.svg`}
            />
            <BoxTitle>EARN DAILY</BoxTitle>
            <BoxText>
              Every 200 reward points earned gets you one entry.
            </BoxText>
          </SideBox>

          <SideBox>
            <IconWrapper
              src={`${process.env.REACT_APP_PGFE_IMG_ASSETS_PATH}promotions/gaming-machines/cashnado-spring-2026/3x.svg`}
            />
            <BoxTitle>3X FRIDAY MULTIPLIER</BoxTitle>
            <BoxText>Earn TRIPLE YOUR ENTRIES every Friday.</BoxText>
          </SideBox>

          <SideBox>
            <IconWrapper
              src={`${process.env.REACT_APP_PGFE_IMG_ASSETS_PATH}promotions/gaming-machines/cashnado-spring-2026/tornado.svg`}
            />
            <BoxTitle>STEP INSIDE</BoxTitle>
            <BoxText>
              Catch as many Cashnado bills as you can in 30 seconds.
            </BoxText>
          </SideBox>

          <SideBox>
            <IconWrapper
              src={`${process.env.REACT_APP_PGFE_IMG_ASSETS_PATH}promotions/gaming-machines/cashnado-spring-2026/money.svg`}
            />
            <BoxTitle>HIT THE JACKPOT</BoxTitle>
            <BoxText>
              Find the 3 specially marked bills to take home the Jackpot!
            </BoxText>
          </SideBox>
        </SideColumn>

        {/* CENTER PANEL */}
        <CenterPanel>
          <DateBanner>JUSQU'AU 3 JUILLET</DateBanner>

          <CenterOverlay>
            <LogoWrapper>
              <img
                src={`${process.env.REACT_APP_PGFE_IMG_ASSETS_PATH}promotions/gaming-machines/cashnado-spring-2026/cashnado-logo-2400px-fr.png`}
                alt="CASHNADO"
              />
            </LogoWrapper>

            <JackpotContainer>
              <JackpotLabel>JACKPOT PROGRESSIF</JackpotLabel>
              <JackpotBlackBox>
                {loading ? <Spinner variant="light" /> : jackpotAmount}
              </JackpotBlackBox>
              <JackpotLabel>PROGRESSIVE JACKPOT</JackpotLabel>
            </JackpotContainer>
          </CenterOverlay>
        </CenterPanel>

        {/* RIGHT COLUMN - French */}
        <SideColumn>
          <SideBox>
            <IconWrapper
              src={`${process.env.REACT_APP_PGFE_IMG_ASSETS_PATH}promotions/gaming-machines/cashnado-spring-2026/star.svg`}
            />
            <BoxTitle>ACCUMULEZ QUOTIDIENNEMENT</BoxTitle>
            <BoxText>
              Une participation par tranche de 200 points de récompense.
            </BoxText>
          </SideBox>

          <SideBox>
            <IconWrapper
              src={`${process.env.REACT_APP_PGFE_IMG_ASSETS_PATH}promotions/gaming-machines/cashnado-spring-2026/3x.svg`}
            />
            <BoxTitle>3X LES VENDREDIS MULTIPLICATEURS</BoxTitle>
            <BoxText>
              Obtenez TROIS FOIS PLUS de participations les vendredis.
            </BoxText>
          </SideBox>

          <SideBox>
            <IconWrapper
              src={`${process.env.REACT_APP_PGFE_IMG_ASSETS_PATH}promotions/gaming-machines/cashnado-spring-2026/tornado.svg`}
            />
            <BoxTitle>ENTREZ DANS LA MACHINE</BoxTitle>
            <BoxText>
              Attrapez autant de billets Cashnado que possible en 30s.
            </BoxText>
          </SideBox>

          <SideBox>
            <IconWrapper
              src={`${process.env.REACT_APP_PGFE_IMG_ASSETS_PATH}promotions/gaming-machines/cashnado-spring-2026/money.svg`}
            />
            <BoxTitle>DÉCROCHEZ LE JACKPOT</BoxTitle>
            <BoxText>
              Trouvez les 3 billets marqués pour remporter le Jackpot!
            </BoxText>
          </SideBox>
        </SideColumn>
      </ContentGrid>
    </TVContainer>
  );
};

// --- STYLED COMPONENTS ---

const TVContainer = styled.div`
  width: 1120px;
  height: 756px;
  background-color: #000;
  color: white;
  overflow: hidden;
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 240px 1fr 240px;
  height: 100%;
`;

const SideColumn = styled.div`
  display: grid;
  grid-template-rows: repeat(4, 1fr);
  gap: 10px;
  padding: 10px;
  background: #000;
`;

const SideBox = styled.div`
  background: radial-gradient(circle at center, #0088cc 0%, #004466 100%);
  border: 2px solid #00aaff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  text-align: center;
  box-shadow: inset 0 0 15px rgba(255, 255, 255, 0.2);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: url('${process.env.REACT_APP_PGFE_IMG_ASSETS_PATH}promotions/gaming-machines/cashnado-spring-2026/cashnado_bg.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.1;
    z-index: 0;
    border-radius: 12px;
  }

  > * {
    position: relative;
    z-index: 1;
  }
`;

const IconWrapper = styled.img`
  height: 50px;
  margin-bottom: 8px;
`;

const BoxTitle = styled.div`
  font-size: 1.1rem;
  font-weight: 900;
  line-height: 1.1;
  margin-bottom: 4px;
  text-transform: uppercase;
`;

const BoxText = styled.div`
  font-size: 0.75rem;
  font-weight: normal;
  line-height: 1.2;
`;

const CenterPanel = styled.div`
  position: relative;
  background: #111;
  display: flex;
  flex-direction: column;
`;

const BackgroundVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
`;

const DynamicAmountOverlay = styled.div`
  position: absolute;
  left: 50%;
  bottom: 6.2%;
  transform: translateX(-50%);
  z-index: 10;
  font-size: 10rem;
  font-weight: 900;
  background: linear-gradient(180deg, #85091f 0%, #cd0000 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  -webkit-text-stroke: 2px #ffffff;
  letter-spacing: -0.02em;
  padding: 0 20px;
`;

const DateBanner = styled.div`
  position: relative;
  z-index: 2;
  background: rgba(0, 153, 204, 0.92);
  backdrop-filter: blur(10px);
  color: white;
  text-align: center;
  font-size: 1.6rem;
  font-weight: 900;
  padding: 12px 20px;
  letter-spacing: 0.12em;
  text-shadow:
    0 0 10px rgba(0, 0, 0, 0.9),
    2px 2px 4px rgba(0, 0, 0, 0.8);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
  max-width: 400px;
  margin: 20px auto;
`;

const CenterOverlay = styled.div`
  position: relative;
  z-index: 3;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  gap: 30px;
`;

const LogoWrapper = styled.div`
  width: 85%;
  max-width: 520px;
  img {
    width: 100%;
    filter: drop-shadow(0 0 25px rgba(255, 255, 255, 0.8));
  }
`;

const JackpotContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const JackpotLabel = styled.div`
  background: #00aaff;
  padding: 4px 20px;
  font-size: 1.2rem;
  font-weight: 900;
  border-radius: 4px;
  margin: 5px 0;
`;

const JackpotBlackBox = styled.div`
  background: #000;
  border: 3px solid #00aaff;
  width: 480px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4.5rem;
  color: white;
  font-weight: 900;
  box-shadow: 0 0 20px rgba(0, 170, 255, 0.6);
`;

export default CashnadoSpring2026TV;
